import React from 'react';
import { FormattedDate } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Box } from '@daedalus/atlas/helpers/Box';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w17hsenv",
  propsAsIs: false
});
interface Props {
  expiresAt: string;
}
export const FrozenUntilBanner: React.FC<Props> = ({
  expiresAt
}) => {
  const {
    isMobile
  } = useDeviceLayout();
  return <Wrapper className={cx(isMobile && '__isMobile')}>
      <Box display="flex" gap="s100" alignItems="center">
        <Icon name={'Ice'} colorPath="content.special.c600" />
        <Text variant="titleS">
          <FormattedMessageWrapper id="df.frozenUntilBannerTitle" defaultMessage="Deal frozen until {date}" values={{
          date: <FormattedDate value={expiresAt} month="long" day="2-digit" />
        }} />
        </Text>
      </Box>
      <Text variant="bodyXS" colorPath="content.neutral.c600">
        <FormattedMessageWrapper id="df.frozenUntilBannerSubtitle" defaultMessage="Complete your booking when you're ready." />
      </Text>
    </Wrapper>;
};

require("./FrozenUntilBanner.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FrozenUntilBanner.tsx");